interface LoadingProps {
  variant?: "text" | "title" | "card";
  count?: number;
}

export function Loading({ variant = "text", count = 1 }: LoadingProps) {
  return (
    <>
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className={`xpn-skeleton xpn-skeleton--${variant}`} />
      ))}
    </>
  );
}

export function LoadingCard() {
  return (
    <div className="xpn-card" style={{ padding: "24px" }}>
      <div className="xpn-skeleton xpn-skeleton--title" />
      <div className="xpn-skeleton xpn-skeleton--text" />
      <div style={{ height: "8px" }} />
      <div className="xpn-skeleton xpn-skeleton--text" style={{ width: "80%" }} />
    </div>
  );
}

export function LoadingStatsGrid() {
  return (
    <div className="xpn-flex xpn-gap-lg xpn-mb-2xl" style={{ flexWrap: "wrap" }}>
      {[1, 2, 3, 4].map((i) => (
        <div
          key={i}
          style={{
            flex: "1",
            minWidth: "150px",
            padding: "24px",
            background: "var(--xpn-surface-1)",
            borderRadius: "var(--xpn-radius-lg)",
            border: "1px solid var(--xpn-border)",
          }}
        >
          <div className="xpn-skeleton xpn-skeleton--text" style={{ width: "60%", marginBottom: "12px" }} />
          <div className="xpn-skeleton xpn-skeleton--text" style={{ width: "40%", height: "28px" }} />
        </div>
      ))}
    </div>
  );
}